<div class="phone-view flex flex__align-items--center">
  <mat-icon color="accent">phone</mat-icon>
  <span *ngIf="!phoneParsed">{{ phone }}</span>
  <a *ngIf="phoneParsed" click-stop-propagation href="{{phoneParsed}}">{{ phone }}</a>
</div>